import { Container } from "@/components/layout/Container"
import { Eyebrow } from "@/components/shared/Eyebrow"
import type { ProductAdvantage } from "@/content/products-content"

interface ProductAdvantagesProps {
	/** Exactamente 6 ventajas con icono lucide coherente con el texto. */
	advantages: ProductAdvantage[]
	title?: string
}

/**
 * Ventajas del producto. Copia del patrón de `treatment/TrustStrip`: rejilla de
 * ítems con icono en caja redondeada `bg-primary/10`, responsiva (1 → 2 → 3
 * columnas). Cada icono se relaciona con su texto; el contenido no repite lo dicho
 * en la sección de descripción.
 */
export function ProductAdvantages({ advantages, title }: ProductAdvantagesProps): React.JSX.Element {
	return (
		<section className="border-y bg-muted/40">
			<Container className="py-16 md:pt-20 md:pb-24">
				<Eyebrow align="center">{title || "Beneficios principales"}</Eyebrow>

				<ul className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
					{advantages.map(({ icon: Icon, title, text }) => (
						<li
							key={title}
							className="flex flex-col items-center gap-3 text-center sm:flex-row sm:items-start sm:text-left"
						>
							<span className="inline-flex size-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
								<Icon className="size-6" />
							</span>
							<div>
								<h3 className="font-semibold">{title}</h3>
								<p className="mt-1 text-sm text-muted-foreground">{text}</p>
							</div>
						</li>
					))}
				</ul>
			</Container>
		</section>
	)
}
